import { Injectable, inject } from '@angular/core';
import { FileSystemService } from '../file-system/file-system.service';

@Injectable({
  providedIn: 'root',
})
export class CleanupService {
  private readonly fileSystemService = inject(FileSystemService);

  private readonly ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

  async cleanupOldFiles(): Promise<void> {
    try {
      await this.cleanupCachedFiles();
    } catch (error) {
      // Silent cleanup - errors are expected and handled
    }
  }

  private async cleanupCachedFiles(): Promise<void> {
    try {
      const { files } = await this.fileSystemService.listCachedFiles();
      const cutoffDate = new Date(Date.now() - this.ONE_MONTH_MS);

      for (const file of files) {
        try {
          // Check if file is older than 1 month
          // Use mtime (modification time) as the primary indicator
          const fileDate = new Date(file.mtime || 0);

          if (fileDate < cutoffDate) {
            await this.fileSystemService.removeFile(file.name);
          }
        } catch (error) {
          // Skip files that can't be deleted
          continue;
        }
      }
    } catch (error) {
      // Silent cleanup - errors are expected and handled
    }
  }
}
